<template>
  <div class="table-responsive" style="margin-bottom: 0px; !important">
    <table class="table table-sm">
      <thead>
        <tr>
          <th style="border: none;"></th>
          <th v-if="!onlyShowSelected && !noAccounts" style="width: 50px;border: none;"></th>
          <th :colspan="debitTableColumns.length" class="table-secondary" style="text-align: center;">Debit</th>
          <th :colspan="creditTableColumns.length" class="table-secondary" style="border-left: 1px solid #dee2e6; text-align: center;">Credit</th>
        </tr>
        <tr>
          <th style="border-top: none;"></th>
          <th v-if="!onlyShowSelected" style="border-top: none;">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" v-model="allSelected" :id="`${id}Switch`" @change="$emit('selectAll', { selected: $event.target.checked })">
              <label class="custom-control-label" :for="`${id}Switch`"></label>
            </div>
          </th>
          <th v-for="(column, index) in debitTableColumns" :key="index" :style="column.style">
            {{ column.label }}
          </th>
          <th v-for="(column, index) in creditTableColumns" :key="index" :style="`${column.style}${index === 0 ? 'border-left: 1px solid #dee2e6;' : ''}`">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="noAccounts" style="text-align: center;background-color: rgba(0, 0, 0, 0.05);"><td :colspan="creditTableColumns.length + debitTableColumns.length + 1">There are no accounts selected</td></tr>      
        
        <template v-for="(account, index) in completeData">
          <FundTransferTableRow :key="account.id"
                                :recordCount="completeData.length"
                                :index="index"
                                :account="account"
                                :creditTableColumns="creditTableColumns"
                                :debitTableColumns="debitTableColumns"
                                :title="title"
                                :onlyShowSelected="onlyShowSelected"
                                :isMinuend="isMinuend"
                                @selectAccount="$emit('selectAccount', { selected: $event.selected, id: $event.id })" />
        </template>
        <tr v-if="!noneSelected && completeData.length > 0">
          <td :colspan="!onlyShowSelected ? debitTableColumns.length + 1 : debitTableColumns.length" style="font-weight: bold;text-align: end;">Subtotal</td>
          <td style="font-weight: bold;text-align: end;">{{ completeDataTotalDebitIDCCredit | currency }}</td>
          <td :colspan="creditTableColumns.length - 1" style="border-left:1px solid #dee2e6; font-weight: bold;text-align: end;">Subtotal</td>
          <td style="font-weight: bold;text-align: end;">{{ completeDataTotalCreditIDCCredit | currency }}</td>
        </tr>

        <template v-for="(account, index) in missingData">
          <FundTransferTableRow :key="account.id"
                                :recordCount="missingData.length"
                                :index="index"
                                :account="account"
                                :creditTableColumns="creditTableColumns"
                                :debitTableColumns="debitTableColumns"
                                title="Missing Data"
                                :onlyShowSelected="onlyShowSelected"
                                :isMinuend="isMinuend"
                                @selectAccount="$emit('selectAccount', { selected: $event.selected, id: $event.id })" />
        </template>
        <tr v-if="!noneSelected && missingData.length > 0">
          <td :colspan="!onlyShowSelected ? debitTableColumns.length + 1 : debitTableColumns.length" style="font-weight: bold;text-align: end;">Subtotal</td>
          <td style="font-weight: bold;text-align: end;">{{ missingDataTotalDebitIDCCredit | currency }}</td>
          <td :colspan="creditTableColumns.length - 1" style="border-left:1px solid #dee2e6; font-weight: bold;text-align: end;">Subtotal</td>
          <td style="font-weight: bold;text-align: end;">{{ missingDataTotalCreditIDCCredit | currency }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td :colspan="!onlyShowSelected ? debitTableColumns.length + 1 : debitTableColumns.length" style="font-weight: bold;text-align: end;">Total</td>
          <td style="font-weight: bold;text-align: end;">{{ totalDebitIDCCredit | currency }}</td>
          <td :colspan="creditTableColumns.length - 1" style="border-left:1px solid #dee2e6; font-weight: bold;text-align: end;">Total</td>
          <td style="font-weight: bold;text-align: end;">{{ totalCreditIDCCredit | currency }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import FundTransferTableRow from "@/components/academicIndirectCost/FundTransferTableRow.vue"
import { currency } from "../../filters/Currency";

export default {
  emits: ["selectAccount", "selectAll"],
  components: {
    FundTransferTableRow
  },
  filters: {
      currency
  },
  props: {
    id: {
      required: true,
      type: String
    },
    accounts: {
      required: true
    },
    creditTableColumns: {
      required: true
    },
    debitTableColumns: {
      required: true
    },
    title: {
      required: true,
      type: String
    },
    canEdit: {
      required: true,
      type: Boolean
    },
    onlyShowSelected: {
      required: true,
      type: Boolean
    },
    isMinuend: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      sections: [
        'complete',
        'missing'
      ]
    }
  },
  computed:{
    missingData() {
      return this.accounts.filter(obj => {
        let isMissingData = false;
        Object.keys(obj).forEach(key => {
          if (obj[key] === null) isMissingData = true;
        });
        return isMissingData;
      });
    },

    completeData() {
      return this.accounts.filter(obj => {
        let isMissingData = false;
        Object.keys(obj).forEach(key => {
          if (obj[key] === null) isMissingData = true;
        });
        return !isMissingData;
      });
    },

    debitAmountKey() {
      const column = this.debitTableColumns.find((obj) => { return obj.isAmount });
      if (column) return column.key;
      return "";
    },
    
    creditAmountKey() {
      const column = this.creditTableColumns.find((obj) => { return obj.isAmount });
      if (column) return column.key;
      return "";
    },

    missingDataTotalCreditIDCCredit() {
      return this.missingData.filter(obj => this.onlyShowSelected ? obj.selected : true ).map((obj) => { return obj[this.creditAmountKey] }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },

    missingDataTotalDebitIDCCredit() {
      return this.missingData.filter(obj => this.onlyShowSelected ? obj.selected : true ).map((obj) => { return obj[this.debitAmountKey] }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },

    completeDataTotalCreditIDCCredit() {
      return this.completeData.filter(obj => this.onlyShowSelected ? obj.selected : true ).map((obj) => { return obj[this.creditAmountKey] }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },

    completeDataTotalDebitIDCCredit() {
      return this.completeData.filter(obj => this.onlyShowSelected ? obj.selected : true ).map((obj) => { return obj[this.debitAmountKey] }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },

    totalCreditIDCCredit() {
      return this.accounts.filter(obj => this.onlyShowSelected ? obj.selected : true ).map((obj) => { return obj[this.creditAmountKey] }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },

    totalDebitIDCCredit() {
      return this.accounts.filter(obj => this.onlyShowSelected ? obj.selected : true ).map((obj) => { return obj[this.debitAmountKey] }).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    },

    noAccounts() {
      return this.accounts.length === 0;
    },

    noneSelected() {
      return this.accounts.filter(obj => this.onlyShowSelected ? obj.selected : true ).length === 0;
    },

    allSelected() {
      return this.accounts.filter(obj => obj.selected ).length === this.accounts.length;
    }
  }
}
</script>
